import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Instant Download', 'No Subscription', 'Lifetime Access', '7-Day Guarantee'];
export function Hero() {
  return <section className="w-full bg-stone-50 px-5 pb-20 pt-5" data-id="element-107" data-mp="9llb731mq8q5">
      <div className="mx-auto max-w-4xl text-center" data-id="element-108" data-mp="4lyswf6y22ah">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-[2.6rem] font-black leading-[1.02] tracking-tight text-stone-900 sm:text-6xl md:text-[4.5rem]" data-id="element-109" data-mp="4njpeactjvaz">
          Solve a Full Year of Hospitality English in Just{' '}
          <span className="italic text-red-500" data-id="element-110" data-mp="nczs94bz7zuk">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-stone-600 sm:text-lg" data-id="element-111" data-mp="3d1aa1ojbgjfe">
          Join 1,500+ teachers and hotel trainers who stopped improvising. Walk
          into every class with real guest scenarios ready to teach, practice,
          and assess.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.18,
        ease: 'easeOut'
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-112" data-mp="39cpain8uf6z7">
          <img src="https://cdn.magicpatterns.com/uploads/2xTZXYvaksfnsrWpr1Qq9v/image.png" alt="The six Hospitality English Ready teacher toolkit volumes, from Reservations and Pre-Arrival to Training Plans and Assessment" className="w-full mix-blend-multiply" data-id="element-113" data-mp="359j9bu0l85zl" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.28,
        ease: 'easeOut'
      }} className="-mt-2 sm:mt-8" data-id="element-114" data-mp="2hl9q8zurdwc5">
          <CtaButton href="#offer" data-id="element-115" data-mp="nbl42pi3sock" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-stone-500 sm:text-sm" data-id="element-116" data-mp="na9yck53l6it">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-117" data-mp="ddwz76qsa0go" data-mpi={index}>
                <span data-id="element-118" data-mp="1b0vubd1tv0cg">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-stone-300" data-id="element-119" data-mp="1ayjhfeaxfg69">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}